import React from 'react'

import FormSubmitButton from './components/FormSubmitButton'
import Captcha from 'components/Captcha'
import {getLang} from 'utils/stringUtils'
import {ruleRunner} from 'utils/validation/ruleRunner'
import {maxLength, isEmail, requiredWithMessage} from 'utils/validation/rules'
import LogisterFormField from './components/LogisterFormField'
import LogisterFormRegisterLink from './components/LogisterFormRegisterLink'
import LogisterFormView from './components/LogisterFormView'
import LogisterFormSubmitButtonContainer from '../LogisterFormSubmitButtonContainer'
import {ELEMENTS_IDS, EMAIL_MAX_LENGTH} from 'const'

const lang = getLang(window.location.search)

const LogisterForm = ({
  t,
  theme,
  data = {},
  errors = {},
  touched = {},
  onChange,
  onSubmit,
  onBlur,
  loading,
  getRegistrationLink,
  shouldShowCaptcha,
  isValid,
}) => {
  const onCaptchaChange = value => onChange({target: {value, name: 'captchaToken'}}, false)

  return (
    <LogisterFormView>
      <form onSubmit={onSubmit} noValidate>
        <LogisterFormField
          name="email"
          type="email"
          label={t('inputs.email')}
          inlineLabel
          value={data.email}
          onChange={onChange}
          onBlur={onBlur}
          error={touched.email && errors.email}
          required
        />
        {shouldShowCaptcha && (
          <Captcha onChange={onCaptchaChange} hl={lang} error={touched.captchaToken && errors.captchaToken} />
        )}
        <LogisterFormSubmitButtonContainer>
          <FormSubmitButton
            id={ELEMENTS_IDS.logisterPage.continue}
            loading={loading}
            disabled={!isValid}
            label="buttons.continue"
            styleType={theme.logisterForm.submitButton}
            margin={0}
          />
          <LogisterFormRegisterLink getRegistrationLink={getRegistrationLink} />
        </LogisterFormSubmitButtonContainer>
      </form>
    </LogisterFormView>
  )
}

export const validations = [
  ruleRunner(
    'email',
    'inputs.email',
    requiredWithMessage('validation.email-required'),
    isEmail,
    maxLength(EMAIL_MAX_LENGTH)
  ),
]

export {LogisterForm as PureLogisterForm}

export default LogisterForm
